/**
 * Convert legacy ATOM's literal two-character "\n" sequences into real line
 * feeds.
 *
 * <p>Legacy ATOM server templates concatenate status/error text using the
 * string {@code "\n"} rather than an actual LF, so a raw message can arrive as
 * {@code "Saved.\\nReview the warnings."}. Callers that render the text with
 * {@code white-space: pre-line} (the snackbar toast) then show it as line
 * breaks instead of a stray backslash-n; callers that render it inline (the
 * message-history popover) collapse the LF to a space — either way the user
 * never sees the literal {@code \n}.
 *
 * <p>Single source for this transform — shared by the AppData message
 * interceptor and every save call site (TSM add-dialog, REF page) so the
 * handling can't drift per app.
 */
export function normalizeNewlines(input: string): string {
	return input.replace(/\\n/g, '\n');
}
